import "./botb-refer-a-friend.css";
import { useBotbRAFContext } from "./context";
import RAFModal from "./components/RAFModal";
import Skeleton from "react-loading-skeleton";
import { PageState } from "./provider";
import { ReferAFriendNotYetAvailable } from "./components/ReferAFriendNotYetAvailable";
import { ReferAFriendRewards } from "./components/ReferAFriendRewards";
import { ReferAFriendDetailsModal } from "./components/ReferAFriendDetailsModal";
import { ReferAFriendStatistics } from "./components/ReferAFriendStatistics";
import CustomHeaderV1 from "@/app/(custom-header)/header/customHeaderV1";

import { TermsAndConditions } from "@/app/(custom-header)/botb-refer-a-friend/components/TermsAndConditions";
import StickyCTADesktop from "@/app/(custom-header)/botb-refer-a-friend/components/StickyCTADesktop";
import StickyCTA from "@/app/(custom-header)/botb-refer-a-friend/components/StickyCTA";
import { useIsMobile } from "@/app/redux/features/device/selectors";

export default function BotBRAFContent() {
  const { state, showMoreDetails, showStatistics, IsRAFEnabled, rafStatus, loading } = useBotbRAFContext();

  const isMobile = useIsMobile();

  return (
    <>
      <div className="flex flex-col min-h-full">
        <CustomHeaderV1 IsRAFEnabled={IsRAFEnabled} />
        <div className="grow flex">
          <div className="mainSection mx-auto flex px-4 lg:px-[1.5rem] pb-14 lg:pb-20">
            <div className="leftSection w-[260px] shrink-0 relative mt-12 max-lg:hidden">
              <h3 className="text-left text-dark-1 font-jost text-2xl font-semibold leading-[30px] !mb-0 uppercase">
                REFER A <br />
                Friend
              </h3>
            </div>

            <div className="rightSection lg:shadow-[-15px_4px_20px_-10px_rgba(0,0,0,0.10)] w-full h-full relative">
              <div className={"flex flex-col min-h-full"}>
                <div className="w-full pt-6 pb-8 lg:py-12 lg:pl-[68px] font-jost space-y-8 lg:space-y-16">
                  {!state ? (
                    <Skeleton
                      count={1}
                      inline
                      highlightColor="#fff"
                      containerClassName="block w-full h-[216px] lg:h-[124px]"
                      className="h-full"
                    />
                  ) : (
                    <div className="w-full flex flex-col items-center gap-5 lg:gap-8">
                      {state === PageState.NOT_AVAILABLE && (
                        <>
                          <ReferAFriendNotYetAvailable />
                        </>
                      )}
                      {state === PageState.REWARDS && (
                        <>
                          <ReferAFriendRewards />
                        </>
                      )}
                    </div>
                  )}
                </div>
                <div className={"mt-auto"}>
                  <TermsAndConditions />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showMoreDetails.show && <ReferAFriendDetailsModal tab={showMoreDetails.tab} />}
      {showStatistics && <ReferAFriendStatistics />}
      {!loading && rafStatus?.referralUrl && <>{isMobile ? <StickyCTA /> : <StickyCTADesktop />}</>}
      {state === PageState.ONBOARDING && (
        <>
          <RAFModal />
        </>
      )}
    </>
  );
}
